import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer } from '@mui/material'
import { useLayoutContext } from '../../contexts/layout.context'
import { useUserStore } from '../../store/user.store'
import aliveLogo from '../../assets/alivelogo.png'
import { Icons } from '../../utils/utilities'
import React, { useState } from 'react'

import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import CustomSwitch from '../common/CustomSwitch'

const menu = [
    { id: 1, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit)\/?$/], permission: true, label: "Dashboard", children: null, link: `/audit`, icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon },
    { id: 11, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit\/online-classes)\/?$/, /^(\/audit\/online-classes)\/list\/?$/, /^(\/audit\/online-classes)\/[\w-]+\/?$/], permission: true, label: "Online Classes", children: null, link: `/audit/online-classes`, icon: Icons.default.OndemandVideoIcon, activeIcon: Icons.default.MeetingRooms },
    { id: 12, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/meetings)\/?$/, /^(\/audit\/meetings)\/list\/?$/, /^(\/audit\/meetings)\/[\w-]+\/?$/], permission: true, label: "Meetings and Webinars", children: null, link: `/audit/meetings`, icon: Icons.default.MeetingRoomsOutlined, activeIcon: Icons.default.MeetingRooms },
    { id: 3, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/study-materials)\/?$/, /^(\/audit\/study-materials)\/list\/?$/], permission: true, label: "Study Material", children: null, link: `/audit/study-materials`, icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon },
    { id: 4, active: true, view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/audit\/assignments)\/?$/, /^(\/audit\/assignments)\/list\/?$/], permission: true, label: "Assignments", children: null, link: `/audit/assignments`, icon: Icons.default.AssignmentIconOutlined, activeIcon: Icons.default.AssignmentIcon },
    { id: 5, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/exams)\/?$/, /^(\/audit\/exams)\/list\/?$/], permission: true, label: "Exam", children: null, link: "/audit/exams", activeIcon: Icons.default.QuizIcon, icon: Icons.default.QuizIconOutlined },
    { id: 13, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/practice-with-simba)\/?$/, /^(\/audit\/practice-with-simba)\/list\/?$/], permission: true, label: "Practice Sessions", children: null, link: "/audit/practice-with-simba", activeIcon: Icons.default.Checklist, icon: Icons.default.Checklist },
    { id: 6, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/quizzes)\/?$/, /^(\/audit\/quizzes)\/list\/?$/], permission: true, label: "Quizzes", children: null, link: "/audit/quizzes", activeIcon: Icons.default.PsychologyAlt, icon: Icons.default.PsychologyAltOutlined },
    { id: 7, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/questionbanks)\/?$/, /^(\/audit\/questionbanks)\/list\/?$/], permission: true, label: "Question Banks", children: null, link: "/audit/questionbanks", activeIcon: Icons.default.QuestionMark, icon: Icons.default.QuestionMarkOutlined },
    { id: 8, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/class-sessions)\/?$/, /^(\/audit\/class-sessions)\/list\/?$/], permission: true, label: "Class Sessions", children: null, link: "/audit/class-sessions", activeIcon: Icons.default.EmojiPeopleIcon, icon: Icons.default.EmojiPeopleIconOutlined },
    { id: 9, active: true, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/discussions)\/?$/, /^(\/audit\/discussions)\/list\/?$/], permission: ["PRINCIPAL", "ADMIN", "SUBADMIN", "is_auditor"], label: "Discussions", children: null, link: "/audit/discussions", activeIcon: Icons.default.Discussions, icon: Icons.default.DiscussionsOutlined },
    { id: 10, active: false, view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/audit\/faculty\/\w+)\/?$/], permission: true, label: "Faculty Audit", children: null, link: "", activeIcon: Icons.default.PeopleAltIcon, icon: Icons.default.PeopleAltIcon },
]

const closedSidebarWidth = 60

const SidedrawerMenuItem = ( { item, isActive, closeOnMobileScreen, active } ) => {

    const [collapseState, setCollapseState] = useState( false )
    const { palette } = useTheme()
    const { pathname, search } = useLocation()


    return (
        <Box borderRadius="5px" bgcolor={collapseState && palette.nav.sidebarHover}>
            <Link className='default-link' target={item.target} to={!item.children ? typeof item.link === 'string' ? item.link : item.link() : `#${item.label}`}>
                <Box
                    onClick={item.children ? () => setCollapseState( !collapseState ) : closeOnMobileScreen}
                    color={palette.nav.font}
                    borderRadius="5px"
                    sx={{
                        cursor: "pointer",
                        position: "relative",
                        background: collapseState ? isActive ? palette.nav.activeSidebarItem : palette.nav.activeSidebarItem + "80" : isActive ? palette.nav.activeSidebarItem : "none",
                        "&:hover": {
                            background: !isActive ? palette.nav.activeSidebarItem + 80 : palette.nav.activeSidebarItem,
                        }
                    }}
                    display="flex"
                    alignItems="center"
                    padding="5px"
                    gap="15px"
                    marginY="5px"
                    minWidth={closedSidebarWidth - 20}
                >
                    <IconButton
                        color="inherit"
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        sx={{
                            padding: "2px",
                            borderRadius: "5px",
                            transform: "scale(0.9)",
                            position: "relative",
                            fontSize: "18px"
                        }}>
                        {isActive ? item.icon : item.icon}
                    </IconButton>
                    <Typography flexGrow={1} display="flex" alignItems="center" justifyContent='space-between' flexShrink={0} color="inherit" variant="subtitle2" fontWeight={isActive ? "500" : "300"} fontSize="14px" textAlign="center">
                        {item.label}
                        {item.children ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ""}
                    </Typography>
                </Box>
            </Link>
            {item.children && <Collapse in={collapseState}>
                <Box flexDirection="column" paddingBottom="10px" display="flex" gap="5px" paddingRight="20px" paddingLeft="30px">
                    {item.children.map( ( sublink, index ) => {
                        const activeChild = item.activeMatchRegexes[index].some( re => active.match( re ) )
                        return <Link className='default-link' key={sublink} to={item.link[index]}>
                            <Box
                                display="flex"
                                onClick={closeOnMobileScreen}
                                borderRadius="5px"
                                padding="2px 5px"
                                gap="20px"
                                alignItems="center"
                                sx={{
                                    color: activeChild ? "white" : "lightgrey",
                                    cursor: "pointer",
                                    position: "relative",

                                    "&::before": {
                                        display: activeChild ? "inline-block" : "none",
                                        content: "''",
                                        position: "absolute",
                                        background: "#fff",
                                        height: "60%",
                                        borderRadius: "0 2px 2px 0",
                                        left: 0,
                                        width: "2px",
                                        zIndex: 324434,
                                        top: "50%",
                                        transform: "translate(0,-50%)"
                                    },

                                    "&:hover": {
                                        textDecoration: "underline",
                                    }
                                }}
                            >
                                <Typography variant="subtitle2" flexShrink={0} color="inherit" fontWeight={activeChild ? "400" : "300"} fontSize="14px" textAlign="center">{sublink}</Typography>
                            </Box>
                        </Link>
                    } )}
                </Box>
            </Collapse>}
        </Box>
    )
}

const SideDrawer = function () {
    const { sidebarOpenState, setNavHeadText, active, setMenuState, menuState, sidebarWidth, minSidebarCollapseWidth } = useLayoutContext()

    const { palette, shadows, border } = useTheme()

    const UserStore = useUserStore()
    const navigate = useNavigate()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            setMenuState( false )
    }

    const toggleAuditMode = () => {
        if ( active.includes( '/audit' ) ) {
            let redirect = localStorage.getItem( 'audit_redirect' )
            if ( !redirect )
                redirect = ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) ? `/admin/home` : `/faculty/home`
            navigate( redirect )
        } else {
            localStorage.setItem( 'audit_redirect', `${active}${window.location.search}` )
            navigate( '/audit/' )
        }
        setMenuState( false )
    }

    useEffect( () => {
        for ( let i = 0; i < menu.length; i++ ) {
            const item = menu[i]
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.label )
                break
            }
        }
    }, [active, setNavHeadText] )

    return (
        <Box>
            <Box display={{ sm: "block", xs: "none" }}>
                <Drawer
                    variant='persistent'
                    sx={{ background: "transparent", position: "initial", overflow: "hidden", width: menuState ? sidebarWidth : 0, height: "100%", flexSrink: 0, display: { sm: "flex", xs: "none" }, flexDirection: "column" }}
                    anchor="left"
                    open={menuState}
                    className="no-scrollbar"
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { width: sidebarWidth, borderRadius: "0", background: palette.layoutBackground, borderRight: "none" } }
                    }}
                >
                    <Box position="relative" flexGrow={1} overflow="auto" display="flex">
                        <Box className="sidebar-scrollbar" display="flex" flexDirection="column" width="100%" overflow="auto" color="GrayText" alignItems="stretch">
                            <Box display="flex" gap="10px" padding="20px 10px" alignItems="center">
                                <Box padding="5px 7px" display="flex" alignItems="center" justifyContent="center" borderRadius="5px" sx={{ aspectRatio: "1 / 1" }} bgcolor="white"><Box component="img" width="20px" src={aliveLogo} alt="Logo" /></Box>
                                <Box>
                                    <Typography color="white" fontSize="14px" variant='h6'>Alive</Typography>
                                    <Typography color="white" fontSize="12px" fontWeight="300" variant='body2'>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: "white", display: { sm: "none", xs: "block" } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box padding="0 10px 20px 10px" className="sidebar-scrollbar" flexGrow={1} overflow="auto">

                                {menu.filter( item => item.active ).map( item => {
                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                    return (
                                        <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    )
                                } )}
                            </Box>
                        </Box>
                    </Box >
                </Drawer >
            </Box>
            <Box display={{ sm: "none", xs: "block" }}>
                <Box display="flex" gap="20px" sx={{ background: `linear-gradient(90deg, rgb(3, 0, 52) 25.54%, rgb(10, 0, 154) 205.66%)` }} alignItems="center" justifyContent="space-evenly" padding="10px 20px">
                    {menu.filter( item => item.active && item.view.includes( "bleeding-bottom-bar" ) ).map( item => {
                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box color={isActive ? palette.nav.activeSidebarItem : "white"} display="flex" alignItems="center" flexDirection="column" gap="5px">
                                        <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{item.icon}</Box>
                                        <Typography color={isActive ? palette.nav.activeSidebarItem : "white"} fontSize="12px" textAlign="center" >{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    <Box sx={{ cursor: "pointer" }} onClick={() => setMenuState( true )} color="white" display="flex" alignItems="center" flexDirection="column" gap="5px">
                        <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{Icons.default.Menu}</Box>
                        <Typography color="white" fontSize="12px" textAlign="center" >More</Typography>
                    </Box>
                </Box>
                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexSrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: "10px 10px 0 0", background: `linear-gradient(90deg, rgb(3, 0, 52) 25.54%, rgb(10, 0, 154) 205.66%)`, borderRight: "none" } }
                    }}
                >
                    <Box position="relative" flexGrow={1} overflow="auto">
                        {( ["PRINCIPAL", "HOD", "ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) || UserStore.getUser.user_auditor ) && <Box display={{ xs: "flex", md: "none" }} onClick={toggleAuditMode} gap="10px" alignItems="center" sx={{ cursor: "pointer" }} justifyContent="space-between" marginBottom="10px" margin="20px" padding="5px 10px" boxShadow={shadows[1]} bgcolor={palette.contentBg} border={border[1]} borderRadius="10px">
                            <Typography fontSize="12px" color={palette.common.font} variant="subtitle2">Audit Mode</Typography>
                            <CustomSwitch size="small" checked={active.startsWith( '/audit' )} onChange={toggleAuditMode} />
                        </Box>}
                        <Box className="sidebar-scrollbar" display="grid" gridTemplateColumns="repeat(3,1fr)" padding="40px 20px" flexWrap="wrap" width="100%" gap="30px" justifyContent="space-evenly" overflow="auto" color="GrayText" alignItems="stretch">
                            {menu.filter( item => item.active && item.view.includes( "opened-bottom-bar" ) ).map( item => {
                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                return (
                                    <Box key={item.id}>
                                        <Link to={item.link} className='default-link' >
                                            <Box color={isActive ? palette.nav.activeSidebarItem : "white"} display="flex" alignItems="center" flexDirection="column" gap="5px">
                                                <Box fontSize="20px" display="flex" alignItems="center" justifyContent="center" >{item.icon}</Box>
                                                <Typography color={isActive ? palette.nav.activeSidebarItem : "white"} fontSize="12px" textAlign="center" >{item.label}</Typography>
                                            </Box>
                                        </Link>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box >
                </SwipeableDrawer >
            </Box>
        </Box >
    )
}

export default SideDrawer


